import {Component, Input, OnInit} from '@angular/core';
import {ListItem} from "../../objects/listItem";
import {CdkDragDrop, moveItemInArray, transferArrayItem} from "@angular/cdk/drag-drop";
import {AppComponent} from "../../app.component";
import {FS3Notification} from "../../objects/notification";
import {SharedDataService} from "../../services/shared-data.service";

@Component({
  selector: 'app-articles-reorder',
  templateUrl: './articles-reorder.component.html',
  styleUrls: ['./articles-reorder.component.css']
})
export class ArticlesReorderComponent implements OnInit {

  @Input() application: AppComponent;
  //@Input() listItems: ListItem[];
  private _listItems: ListItem[];
  public get listItems(): ListItem[] {
    return this._listItems;
  }
  @Input() public set listItems(value: ListItem[]) {
    this._listItems = value;
  }
  @Input() state: string;
  @Input() payload: object;

  constructor(private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
  }

  dropArticleCategory(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }

    this.saveNewArticlePositions();
  }
  dropArticleItem(event: CdkDragDrop<string[]>) {
    this.dropArticleCategory(event); //same func will fit
  }

  saveNewArticlePositions() {
    let newArticlesPositions = this._listItems.map( (category, index) => {
      let ret = {};
      ret['sorder'] = index;
      ret['group_name'] = category['group_name'];
      ret['group_key'] = category['group_key'];
      ret['group_image_src'] = category['group_image_src'];
      ret['articles_uuids'] = category['articles'].map( (article) => {
        return article['itemFullData']['uuid'];
      });
      return ret;
    })
    this.application.apiService
      .updateArticlesGroups(newArticlesPositions,this.payload['folderUUID'])
      .subscribe(
        data => {
          let notification = new FS3Notification();
          notification.type = 'success';
          notification.text = 'Updated';
          this.sharedDataService.pushNotification(notification);
        },
        error => {
          const { exception } = error;
          if (exception && exception.error && exception.error.message) {
            let notification = new FS3Notification();
            notification.type = 'error';
            notification.text = exception.error.message;
            this.sharedDataService.pushNotification(notification);
          } else {
            //maybe close dialog
          }
        }
      )
  }
}
